export default __webpack_public_path__ + "static/media/DeveloperGuidelines_Summary.21ab214b.png";